<template>
  <div>
    <!-- <div id="login">
      <div class="mx-auto" v-if="loadings">
        <div class="spinner-grow text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div class="container">
        <FlashMessage :position="'right top'" />
        <form>
          <div>
            <div class="title display-3" id="title">Login</div>
            <div class="form-group">
              <input
                type="email"
                class="form-control"
                placeholder="Enter your email"
                v-model="email"
              />
            </div>

            <div class="form-group">
              <input
                type="password"
                class="form-control"
                placeholder="Enter your password"
                v-model="password"
              />
            </div>
          </div>
          <button class="btn btn-block" v-on:click.prevent="posting">
            submit
          </button>
          <router-link style="float: left" to="/register">
            register
          </router-link>
          <router-link style="float: right" to="/resetpassword">
            forgot password ?
          </router-link>
        </form>
      </div>
    </div> -->
  <div id="login" > 
     <div class="mx-auto" v-if="loadings">
        <div class="spinner-grow text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    <div class="mx-auto login-form">
       <FlashMessage :position="'right top'" />
        <form>
            <h2 class="text-center">Login</h2>       
            <div class="form-group">
                <input type="text" class="form-control" placeholder="Email Address" v-model="email" required="required">
            </div>
            <div class="form-group">
                <input type="password" class="form-control" placeholder="Password" v-model="password" required="required">
            </div>
            <div class="form-group">
                <button type="submit" v-on:click.prevent="posting" class="btn btn-primary btn-block">Login</button>
            </div>
            <div class="clearfix">
            <router-link style="float: right" to="/resetpassword">
              Forgot Password?
            </router-link>  
            </div>        
        </form>
        <p class="text-center">
           <router-link style="text-align:center" to="/register">
            Create an Account
          </router-link>
        </p>
    </div>
  </div>

  </div>
</template>

<script>
import axios from "axios";
//import { fb } from "../firebase";
export default {
  data() {
    return {
      email: "",
      password: "",
      loadings: false,
    };
  },

  methods: {
    posting: async function () {
      this.loadings=true
      await axios
        .post("https://pg-v1.herokuapp.com/csignin", {
          email: this.email,
          password: this.password,
        })
        .then((res) => {
          console.log(res);

          localStorage.setItem("email", btoa(this.email));
          localStorage.setItem("password", btoa(this.password));

          localStorage.setItem("localid", res.data.localId);
          localStorage.setItem("idtoken", res.data.idToken);
          this.$router.push("cremainder");
          location.reload();
          location.reload();
        })
        .catch((err) => {
          console.log(err.response);

          this.flashMessage.setStrategy("single");
          this.flashMessage.error({
            message: err.response.data.message,
            time: 3000,
            blockClass: "custom-block-class",
          });
        });
         this.loadings=false
    },
  },

  async created() {
    if (
      atob(localStorage.getItem("email")) != null &&
      atob(localStorage.getItem("password")) != null &&
      localStorage.getItem("email") != null &&
      localStorage.getItem("password") != null
    ) {
      this.loadings = true;
      await axios
        .post("https://pg-v1.herokuapp.com/csignin", {
          email: atob(localStorage.getItem("email")),
          password: atob(localStorage.getItem("password")),
        })
        .then((res) => {
          console.log(res);
          localStorage.setItem("localid", res.data.localId);
          localStorage.setItem("idtoken", res.data.idToken);
          this.$router.push("cremainder");
          location.reload();
          location.reload();
        })
        .catch((err) => {
          console.log(err.response);

          this.flashMessage.setStrategy("single");
          this.flashMessage.error({
            message: err.response.data.message,
            time: 3000,
            blockClass: "custom-block-class",
          });
        });
      this.loadings = false;
    }
  },
};
</script>


<style  scoped>

  /* src='../assets/css/login.css' */

  .spinner-grow{
  position: fixed;
  left: 0px;
  top: 25%;
  width: 100%;
  height: 50%;
  z-index: 9999;
  background: url('//upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Phi_fenomeni.gif/50px-Phi_fenomeni.gif') 
              50% 50% no-repeat;
}


  #login{
      display: block;
      overflow: auto;
      background-color: #dcdcdc;
      min-height: 100vh;
  }

  @media only screen and (max-width: 600px) {
   
  .login-form {
      padding-top: 250px;
      width: 340px;
      /* padding-top: 50px auto; */
    }
}


    /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    .login-form {
      padding-top: 250px;
      width: 340px;
      /* padding-top: 50px auto; */
    }
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    .login-form {
        padding-top: 250px;
        width: 340px;
        /* padding-top: 50px auto; */
      }
  } 

  @media only screen and (min-width: 992px) {
    .login-form {
      padding-top: 250px;
      width: 500px;
      /* padding-top: 50px auto; */
    }
  } 

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
  .login-form {
      padding-top: 250px;
      width: 500px;
      /* padding-top: 50px auto; */
    }
  }

  
  .login-form form {
    margin-bottom: 15px;
    background: #f7f7f7;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    padding: 30px;
  }
    .login-form h2 {
        margin: 0 0 15px;
    }
    .form-control, .btn {
        min-height: 38px;
        border-radius: 2px;
    }
    .btn {        
        font-size: 15px;
        font-weight: bold;
    }

    input{
  text-align: center;
}



</style>
